<template>
  <div :class="[bannerPic ? 'bg_image' : 'bg_image_web']" :style="bgStyle">
  
    
    <img v-if="!isSlotsRedirect" :src="'../../static/images/' + logoImage"/>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import {isSlotsRedirect as hasSlotsRedirect} from '../utils/favicon'

  export default {

    name: 'bannerBg',
    computed: {
      ...mapState([
        'platform',
        'brandName'
      ]),
      isSlotsRedirect () {
        return hasSlotsRedirect()
      },
      bgImage () {
        return this.isSlotsRedirect ? 'HeroPPGC.jpg' : `bg2_${this.brandName}.png`
      },
      logoImage () {
        return `logo_${this.brandName}.png`
      },
      bgStyle () {
        return {
          backgroundImage: `url('../../static/images/${this.bgImage}')`,
          backgroundColor: this.isSlotsRedirect ? '#071b2d' : 'white',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%',
          backgroundSize: 'cover'
        }
      }
    },

    data () {
      return {
        bannerPic: this.platform === 'LegendHill'
      }
    }

  }
</script>

<style scoped>
  @import '../assets/css/main.css';
  @import '../assets/css/username.css';
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue